// extracted by mini-css-extract-plugin
export var redoItem = "_ni-1";
export var redoTrigger = "_ni-0";